<label ngFileDrop [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" class="uploader-label">
    <p *ngIf="!isLoading">{{file ? file.name : ('DRAG FILES HERE OR CLICK TO BROWSE TO UPLOAD' | translate) }}</p>
    <mat-spinner diameter="36" *ngIf="isLoading"></mat-spinner>
    <input type="file" ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" [accept]="accept" class="uploader-input" />
</label>
